import { createSlice } from '@reduxjs/toolkit';

export const supportSlice = createSlice({
    name: 'support',
    initialState: {
        wpnumber: '',
        instagram: '',
        facebook: '',
        twitter: '',
        telegram: '',
        email: '',
        message: '',
        showMessage: false,
    },
    reducers: {
        setSupport: (state, action) => ({ ...state, 
            wpnumber:  action.payload?.wpnumber || '',
            instagram: action.payload?.instagram || '',
            facebook:  action.payload?.facebook || '',
            twitter:  action.payload?.twitter || '',
            telegram: action.payload?.telegram || '',
            email:  action.payload?.email || '',
            message: action.payload?.message || '',
            showMessage: action.payload.message? true : false
        }),
        setShowMessage: (state, action) => ({ ...state, showMessage: action.payload }),
    },
})


export const { setSupport, setShowMessage } = supportSlice.actions

export default supportSlice.reducer
